import { BookOpenTextIcon, ClipboardCheckIcon, FolderKanbanIcon, LightbulbIcon, SearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  listLabel?: string;
  items?: string[];
  note?: string;
  benefit?: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Actividades y Desafíos para Enseñar Criminalística',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre fundamentos, lugar de los hechos, indicios y evidencias, dactiloscopía, biología forense, documentos, química, criminalística digital y análisis integral. Organizadas por nivel de dificultad.',
    note: 'Incluyen actividades de análisis, comparación, resolución de problemas, interpretación, argumentación y reflexión.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluación Docente de Criminalística',
    description: 'Recursos completos para evaluar conocimientos y competencias:',
    items: [
      'Evaluaciones diagnósticas',
      'Evaluaciones temáticas (por cada área)',
      'Evaluaciones integradoras',
      'Preguntas de respuesta breve y desarrollo',
      'Verdadero o falso con justificación',
      'Detección y corrección de errores',
      'Criterios de orientación para el docente',
      'Rúbricas',
      'Listas de cotejo',
    ],
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Casos y Situaciones Problemáticas de Criminalística para el Aula',
    description:
      '100 situaciones educativas ficticias para que los estudiantes apliquen conocimientos en contextos problemáticos.',
    listLabel: 'Los casos permiten trabajar:',
    items: [
      'Análisis del lugar de los hechos',
      'Identificación e interpretación de indicios',
      'Evidencia física y biológica',
      'Huellas e identificación',
      'Genética forense',
      'Documentos',
      'Química y toxicología',
      'Evidencia digital',
      'Evidencias contradictorias',
      'Formulación y comparación de hipótesis',
      'Argumentación de conclusiones',
    ],
    note: 'Promoviendo análisis de información, identificación de problemas, comparación de alternativas y justificación de respuestas.',
    benefit: 'Tus alumnos aprenden analizando situaciones reales de criminalística.',
    value: 'USD 14',
    icon: SearchIcon,
  },
  {
    number: '04',
    title: 'Diccionario Docente de Criminalística: 200 Conceptos Explicados para el Aula',
    description: 'Una herramienta de consulta con 200 conceptos fundamentales explicados de forma clara y educativa.',
    listLabel: 'Incluye terminología relacionada con:',
    items: [
      'Criminalística general',
      'Lugar de los hechos',
      'Indicios y evidencias',
      'Cadena de custodia',
      'Dactiloscopía',
      'Identificación',
      'Biología y genética',
      'Documentología',
      'Química y toxicología',
      'Criminalística digital',
      'Metodología científica',
      'Terminología forense',
    ],
    note: 'Con aclaraciones de conceptos que suelen confundirse, facilitando su enseñanza.',
    value: 'USD 14',
    icon: BookOpenTextIcon,
  },
  {
    number: '05',
    title: '50 Proyectos de Investigación y Análisis de Criminalística para el Aula',
    description:
      'Una colección de 50 proyectos para profundizar los contenidos con propuestas de mayor profundidad y duración.',
    listLabel: 'Los proyectos permiten trabajar:',
    items: [
      'Historia y evolución de la Criminalística',
      'Ciencias forenses',
      'Análisis de indicios y evidencias',
      'Sistemas de identificación',
      'Genética forense',
      'Documentos y escritura',
      'Toxicología y química forense',
      'Criminalística digital',
      'Tecnología aplicada',
      'Investigación de casos ficticios',
      'Ética y responsabilidad científica',
      'Proyectos integradores',
    ],
    note: 'Cada proyecto incluye objetivos, procedimientos y recursos necesarios.',
    benefit: 'Tus alumnos salen con proyectos reales en sus portafolios.',
    value: 'USD 14',
    icon: FolderKanbanIcon,
  },
];
